import type { FetchBaseQueryError, FetchBaseQueryMeta, QueryReturnValue } from '@reduxjs/toolkit/query';

import { baseApi } from '../../base-api';
import { IGetAvailableModelsResponse, IModel } from '../../types';

export const appsUrl = `${process.env.REACT_APP_APPS_SERVICE_URL}`;

const baseApiWithTags = baseApi.enhanceEndpoints({});

export const settingsEndpoints = baseApiWithTags.injectEndpoints({
    endpoints: (builder) => ({
        getAvailableModels: builder.query<IModel[], null>({
            queryFn: async (_args, _queryApi, _extraOptions, baseQuery) => {
                const response = await baseQuery({
                    url: `${appsUrl}/available-models`,
                    method: 'GET',
                });

                const { error, data } = response as QueryReturnValue<
                    IGetAvailableModelsResponse,
                    FetchBaseQueryError,
                    FetchBaseQueryMeta
                >;

                if (error) {
                    return { error };
                }

                const { models } = data;

                const sortedModels = (models ?? []).sort((a, b) => {
                    if (a.is_recommended === b.is_recommended) {
                        return 0;
                    }
                    return a.is_recommended ? -1 : 1;
                });

                return { data: sortedModels, error };
            },
        }),
    }),
});

export const { useGetAvailableModelsQuery } = settingsEndpoints;
